// extracted by mini-css-extract-plugin
export var externalLink = "_8y-0";
export var internalLinkLabel = "_8y-1";